var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83325 14.1663V15.833C3.83325 16.275 4.00885 16.699 4.32141 17.0115C4.63397 17.3241 5.05789 17.4997 5.49992 17.4997H15.4999C15.9419 17.4997 16.3659 17.3241 16.6784 17.0115C16.991 16.699 17.1666 16.275 17.1666 15.833V14.1663M6.33325 9.16634L10.4999 13.333M10.4999 13.333L14.6666 9.16634M10.4999 13.333V3.33301",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlueIcon);
export default __webpack_public_path__ + "static/media/downloadBlueIcon.98f2abb0b126fd8afe99fc27f39e659e.svg";
export { ForwardRef as ReactComponent };